import type { NodeTypes } from '@mv/core/model/heim/richText';
import { type PlaceholderReplacements, replacePlaceholders } from '../replacePlaceholders';

export function getPlainText(nodes: NodeTypes[] | undefined, replacements: PlaceholderReplacements): string {
	return (
		nodes
			?.map((node) =>
				node.type === 'text'
					? replacePlaceholders(node.text ?? '', replacements)
					: getPlainText(node.children, replacements),
			)
			.join('')
			.replace(/\s+/g, ' ')
			.trim() ?? ''
	);
}
